/**
 * Useful for exhaustive type checking
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function assertNever(x: never): never {
  throw new Error('Unexpected value. Should have been never.');
}
